import React from "react";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

interface MenuButtonProps {
  onOpen: () => void;
  isOpen: boolean;
}

const MenuButton = ({ onOpen, isOpen }: MenuButtonProps) => {
  return (
    <IconButton
      aria-label="open drawer"
      onClick={onOpen}
      edge="start"
      sx={{
        ...(isOpen && { display: "none" }),
        color: "white",
      }}
    >
      <MenuIcon />
    </IconButton>
  );
};

export default MenuButton;
